module.exports = __webpack_public_path__ + "static/media/32.8a340a32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/32.jpg
// module id = 593
// module chunks = 0